import { connect } from "react-redux";
import InfoDialog from "./InfoDialog";
import { clearNotification } from "./actions/notifications";

const mapStateToProps = (state, ownProps) => {
  return {
    content: state.ui.notification,
    open: state.ui.notification && state.ui.notification.show === "dialog"
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onDismiss: () => {
      dispatch(clearNotification());
    }
  };
};

const InfoDialogContainer = connect(mapStateToProps, mapDispatchToProps)(
  InfoDialog
);

export default InfoDialogContainer;



// WEBPACK FOOTER //
// ./src/InfoDialogContainer.js